// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  default as InboundMessage
} from './InboundMessage'

import {
  default as OutboundMessage
} from './OutboundMessage'

import { readablePhoneNumber, getNodeTypeFromBase64Id } from '../../utils'


export class MessageList extends React.PureComponent {
  static propTypes = {
    messages: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedMessage: PropTypes.string.isRequired,
    onMessageClick: PropTypes.func.isRequired,
    scrollIntoView: PropTypes.func.isRequired,
    onMounted: PropTypes.func.isRequired,
    refs: PropTypes.object.isRequired
  }

  static defaultProps = {
    className: ''
  }

  componentDidMount() {
    this.props.onMounted()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedMessage !== this.props.selectedMessage) {
      this.props.scrollIntoView(this.props.selectedMessage, this.props.refs)
    }
  }

  render() {
    let { messages, selectedMessage, refs, onMessageClick, className } = this.props

    return (
      <ul className={`chat-list ${className}`}>
        {messages.map(message => {
          const selected = selectedMessage === message.id
          const fromAddr = message.fromWaId || message.fromAddr
          const isSMS = getNodeTypeFromBase64Id(message.id) === 'MessageNode'

          if (message.direction === 'INBOUND') {
            return (
              <InboundMessage
                type={message.messageType}
                fromIdentityName={message.fromIdentity
                  ? `${message.fromIdentity.fullName} (${readablePhoneNumber(fromAddr)})`
                  : `Unknown (${readablePhoneNumber(fromAddr)})`
                }
                createdAt={message.createdAt}
                body={message.body || message.content}
                selected={selected}
                onClick={() => onMessageClick(message.id)}
                key={message.id}
                ref={refs[message.id]}
                isSMS={isSMS}
              />
            )
          } else {  // OUTBOUND
            return (
              <OutboundMessage
                type={message.messageType}
                createdAt={message.createdAt}
                body={message.body || message.content}
                status={message.status}
                selected={selected}
                onClick={() => onMessageClick(message.id)}
                key={message.id}
                ref={refs[message.id]}
                isSMS={isSMS}
              />
            )
          }
        })}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/employer-related-messages-list/MessageList.js